<template>
    <div class="footer">
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'zViewFooter'
}
</script>
<style lang="scss" scoped>
.footer {

}
</style>